import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { List } from "antd-mobile";
import axios from "axios";
import { LeftOutlined } from "@ant-design/icons";
import emptyImg from "../assets/empty.png";
import kefuImg from "../assets/kefu.png";
import dayjs from "dayjs";
import { HOST } from "../tool/api";


interface QueryItem {
  title: string;
  registerTime: string;
  orderContent: string;
  handleState: string;
  handleNote: string;
  handleTime: string;
  typeName: string;
}

export default function ListPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const phone:any = searchParams.get("phone");
  const typeCode = searchParams.get("typeCode");
  const token = searchParams.get("token");
  const [queryList, setQueryList] = useState<QueryItem[]>([]);
  const [contentExpandedItems, setContentExpandedItems] = useState<{
    [key: number]: boolean;
  }>({});
  const [noteExpandedItems, setNoteExpandedItems] = useState<{
    [key: number]: boolean;
  }>({});
  const [showExpandButtons, setShowExpandButtons] = useState<{
    [key: number]: boolean;
  }>({});
  const [showNoteExpandButtons, setShowNoteExpandButtons] = useState<{
    [key: number]: boolean;
  }>({});
  const contentRefs = useRef<{ [key: number]: HTMLDivElement }>({});
  const noteRefs = useRef<{ [key: number]: HTMLDivElement }>({});

  const back = () => {
    navigate(-1);
  };

  const getList = (phone: string) => {
    // 获取图形验证码
    const url = HOST+"/sys/api/exchange/user/ordersearch/getorderbyphone"
    axios
      // .post(`${HOST}/sys/api/exchange/order/getorderbyphone`,
      .post(url,
         {
        applicantPhone: phone,
        typeCode,
        captchaId:token
      })
      .then((res) => {
        console.log("resresres", res);
        setQueryList(res.data.data || []);
      });
  };

  useEffect(() => {
    getList(phone);
  }, [phone]);

  useEffect(() => {
    queryList.forEach((_, index) => {
      const element = contentRefs.current[index];
      const noteElement = noteRefs.current[index];
      if (element) {
        const lineHeight = parseInt(
          window.getComputedStyle(element).lineHeight
        );
        const height = element.clientHeight;
        const isOverflowing = height < element.scrollHeight;
        setShowExpandButtons((prev) => ({
          ...prev,
          [index]: isOverflowing,
        }));
      }
      if (noteElement) {
        const lineHeight = parseInt(
          window.getComputedStyle(noteElement).lineHeight
        );
        const height = noteElement.clientHeight;
        const isOverflowing = height < noteElement.scrollHeight;
        setShowNoteExpandButtons((prev) => ({
          ...prev,
          [index]: isOverflowing,
        }));
      }
    });
  }, [queryList]);

  return (
    <div
      style={{
        height: "100%",
        minHeight: "100vh",
        backgroundColor: "#FFF",
      }}
    >
      <div
        style={{
          height: "45px",
          display: "flex",
          alignItems: "center",
          padding: "0 12px",
          marginBottom: "16px",
          backgroundColor: "#FAFAFA",
          fontWeight: 600,
          fontSize: "17px",
        }}
      >
        <LeftOutlined onClick={back} />
        <div style={{ flex: 1, textAlign: "center" }}>查询结果</div>
      </div>

      <div className="content">
        {queryList.length > 0 ? (
          <>
            <div
              style={{
                fontSize: "16px",
                marginBottom: "12px",
                padding: "14px 16px",
                borderBottom: "1px solid #f5f5f5",
              }}
            >
              您的手机号码：{phone}
            </div>
            <List>
              {queryList.map((item, index) => (
                <List.Item
                  key={index}
                  style={{
                    // marginBottom: "12px",
                    borderRadius: "8px",
                    backgroundColor: "white",
                    padding: "4px 16px",
                  }}
                >
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "12px",
                        fontSize: "18px",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: 500,
                          display: "flex",
                          // alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "36px",
                            height: "24px",
                            backgroundColor: "#EFF3F7",
                            color: "#6687E0",
                            padding: "4px 8px",
                            whiteSpace: "nowrap",
                            marginRight: "8px",
                            borderRadius: "8px",
                          }}
                        >
                          {item.typeName}
                        </div>
                        <div style={{ lineHeight: "32px", fontWeight: "bold" }}>
                          {item.title}
                        </div>
                      </div>

                      <div
                        style={{
                          color: "#666",
                          fontSize: "14px",
                          display: "flex",
                          gap: "16px",
                          whiteSpace: "nowrap",
                          lineHeight: "24px",
                        }}
                      >
                        {item.registerTime &&
                          dayjs(item.registerTime).format("YYYY-MM-DD")}
                      </div>
                    </div>
                    <div
                      ref={(el) => {
                        if (el) contentRefs.current[index] = el;
                      }}
                      style={{
                        fontSize: "16px",
                        color: "#333",
                        lineHeight: "20px",
                        display: "-webkit-box",
                        WebkitLineClamp: contentExpandedItems[index]
                          ? "unset"
                          : 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        position: "relative",
                        cursor: "pointer",
                      }}
                    >
                      {item.orderContent}
                    </div>
                    <div
                      style={{
                        color: "#3769F4",
                        fontSize: "16px",
                        textAlign: "right",
                        width: "100%",
                      }}
                      onClick={() =>
                        setContentExpandedItems((prev) => ({
                          ...prev,
                          [index]: !prev[index],
                        }))
                      }
                    >
                      {showExpandButtons[index] && (
                        <span>
                          {contentExpandedItems[index] ? "收起" : "展开"}
                        </span>
                      )}
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: "12px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            style={{ width: 18, height: 18 }}
                            src={kefuImg}
                            alt=""
                          />
                          <span style={{ marginLeft: 4, color: "#999" }}>
                            回复结果:
                            {!item.handleNote && (
                              <span style={{ marginLeft: 8 }}>暂无结果</span>
                            )}
                          </span>
                        </div>
                        <div
                          style={{
                            color:
                              item.handleState === "已处理"
                                ? "#52c41a"
                                : item.handleState === "未处理"
                                ? "rgb(240 163 19)"
                                : "#ff4d4f",
                            fontSize: "14px",
                          }}
                        >
                          {item.handleState}
                        </div>
                      </div>
                    </div>
                    {item.handleNote && (
                      <>
                        <div
                          ref={(el) => {
                            if (el) noteRefs.current[index] = el;
                          }}
                          style={{
                            marginTop: "12px",
                            fontSize: "16px",
                            color: "red",
                            lineHeight: "20px",
                            display: "-webkit-box",
                            WebkitLineClamp: noteExpandedItems[index]
                              ? "unset"
                              : 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            position: "relative",
                          }}
                        >
                          {item.handleNote}
                        </div>
                        <div
                          style={{
                            color: "#3769F4",
                            fontSize: "16px",
                            textAlign: "right",
                            width: "100%",
                          }}
                          onClick={() =>
                            setNoteExpandedItems((prev) => ({
                              ...prev,
                              [index]: !prev[index],
                            }))
                          }
                        >
                          {showNoteExpandButtons[index] && (
                            <span>
                              {noteExpandedItems[index] ? "收起" : "展开"}
                            </span>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </List.Item>
              ))}
            </List>
          </>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "calc(100vh - 350px)",
              color: "#999",
              fontSize: "16px",
            }}
          >
            <img
              style={{ width: 120, marginBottom: 16 }}
              src={emptyImg}
              alt=""
            />
            <div>您查询的手机号：{phone}</div>
            <div>没有工单内容</div>
          </div>
        )}
      </div>
    </div>
  );
}
